import React, {Component} from "react";
import PropTypes from "prop-types";
import './styles.css';

class NavigationContainer extends Component {
  static propTypes = {
    children: PropTypes.node,
    getItemPositions: PropTypes.func,
    getCurrentItemPosition: PropTypes.func,
    excludedWidth: PropTypes.number,
    opacity: PropTypes.number,
  };
  static defaultProps = {
    children: null,
    getItemPositions: null,
    getCurrentItemPosition: null,
    excludedWidth: 0,
    opacity: 0,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      containerWidth: 0,
      contentWidth: 0,
      positionLeft: 0,
      scrollEnabled: false,
      disabledPrev: true,
      disabledNext: false,
      maxWidth: 'auto',
      opened: false,
      opacity: this.props.opacity,
    };
    this.containerWidth = 0;
    this.contentWidth = 0;
    this.positionLeft = 0;
    //
    this.itemPositions = [];
    this.currentItemPosition = 0;
    this.desktop = null;
    this.isTablet = false;
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    setTimeout(() => {
      this.handleResize();
      this.setCurrentCenter();
    }, 200);
  };
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  
  render() {
    return (
      <div
        className={'NavigationContainer' + ((this.isTablet === true) ? ' tablet': '') + ((this.state.opened === true) ? ' opened': '')}
        style={{opacity: this.state.opacity}}
        ref="navigationContainer"
      >
        <div className="NavigationContainer__container-left">
          <a
            className={'NavigationContainer__link-prev' + ((this.state.scrollEnabled) ? ' enabled': '') + ((this.state.disabledPrev) ? ' disabled': '')}
            href="#"
            onClick={this.prev}
          >
            {'Prev'}
          </a>
        </div>
        <div className="NavigationContainer__container-center"
             style={{maxWidth: this.state.maxWidth}}
             ref="container"
        >
          <div
            className="NavigationContainer__content"
            ref="content"
            style={{left: this.state.positionLeft}}
          >
            {this.props.children}
          </div>
        </div>
        <div className="NavigationContainer__container-right">
          <a
            className={'NavigationContainer__link-next' + ((this.state.scrollEnabled) ? ' enabled': '') + ((this.state.disabledNext) ? ' disabled': '')}
            href="#"
            onClick={this.next}
          >
            {'Next'}
          </a>
        </div>
      </div>
    )
  }
  
  //
  setCurrentCenter = () => {
    this.containerWidth = this.refs.container.clientWidth;
    this.contentWidth = this.refs.content.scrollWidth;
    this.currentItemPosition = this.props.getCurrentItemPosition();
    //
    if (this.contentWidth <= this.containerWidth) {
      this.positionLeft = 0;
      this.setState({
        positionLeft: this.positionLeft,
        opacity: 1,
      });
    } else {
      this.positionLeft = this.currentItemPosition - (this.containerWidth / 2);
      if ((this.contentWidth - this.containerWidth) < this.positionLeft) this.positionLeft = this.contentWidth - this.containerWidth;
      if (this.positionLeft < 0) this.positionLeft = 0;
      //
      this.setState({
        positionLeft: -this.positionLeft,
        opacity: 1,
      });
    }
    //
    this.checkDisabledLink();
  };
  
  //
  handleResize = () => {
    if (this.state.open === false) return;
    this.containerWidth = this.refs.container.clientWidth;
    this.contentWidth = this.refs.content.scrollWidth;
    //
    if (this.contentWidth <= this.containerWidth) {
      this.setState({
        containerWidth: this.containerWidth,
        contentWidth: this.contentWidth,
        scrollEnabled: false,
      });
    } else {
      this.setState({
        containerWidth: this.containerWidth,
        contentWidth: this.contentWidth,
        scrollEnabled: true,
      });
    }
    //
    if (1360 <= document.body.clientWidth) {
      this.setState({
        maxWidth: 1220 - (this.props.excludedWidth + 60),
        //maxWidth: 1220 - this.props.excludedWidth,
      });
    } else if (768 <= document.body.clientWidth) {
      this.setState({
        maxWidth: document.body.clientWidth - (this.props.excludedWidth + 80 + 60),
        //maxWidth: document.body.clientWidth - 140 - this.props.excludedWidth,
      });
    } else {
      this.setState({
        maxWidth: 'auto',
      });
    }
    //
    if (window.innerWidth <= 1024) {
      if (this.desktop === true) {
        this.desktop = false;
        this.setState({
          positionLeft: 0,
        });
        this.refs.container.scrollLeft = 0;
      }
    } else {
      if (this.desktop === false) {
        this.desktop = true;
        this.setState({
          positionLeft: 0,
        });
        this.refs.container.scrollLeft = 0;
      }
    }
    //
    this.checkDisabledLink();
  };
  
  //
  prev = (e) => {
    e.preventDefault();
    //
    this.itemPositions = this.props.getItemPositions();
    let left = 0;
    let i;
    for (i = this.itemPositions.length - 1; 0 <= i; i = i - 1) {
      if (this.itemPositions[i] <= this.positionLeft - this.containerWidth) {
        break;
      } else {
        left = this.itemPositions[i];
      }
    }
    this.positionLeft = left;
    if (this.positionLeft < 0) {
      this.positionLeft = 0;
      this.setState({
        positionLeft: -this.positionLeft,
        opened: true,
      });
    } else {
      this.setState({
        positionLeft: -this.positionLeft,
        opened: true,
      });
    }
    this.checkDisabledLink();
  };
  
  //
  next = (e) => {
    e.preventDefault();
    //
    this.itemPositions = this.props.getItemPositions();
    let left = 0;
    let i, max;
    for (i = 0, max = this.itemPositions.length; i < max; i = i + 1) {
      if (this.containerWidth + this.positionLeft <= this.itemPositions[i]) {
        break;
      } else {
        left = this.itemPositions[i];
      }
    }
    this.positionLeft = left;
    if (this.itemPositions[this.itemPositions.length - 1] - this.containerWidth <= this.positionLeft) {
      this.positionLeft = this.itemPositions[this.itemPositions.length - 1] - this.containerWidth;
      this.setState({
        positionLeft: -this.positionLeft,
        opened: true,
      })
    } else {
      this.setState({
        positionLeft: -this.positionLeft,
        opened: true,
      })
    }
    this.checkDisabledLink();
  };
  
  //
  checkDisabledLink = (e) => {
    //
    if (this.positionLeft <= 0) {
      this.setState({
        disabledPrev: true,
      })
    } else {
      this.setState({
        disabledPrev: false,
      })
    }
    //
    if (this.contentWidth - this.containerWidth <= this.positionLeft) {
      this.setState({
        disabledNext: true,
      })
    } else {
      this.setState({
        disabledNext: false,
      })
    }
  }
  
}

export default NavigationContainer;



// WEBPACK FOOTER //
// ./src/components/navigation-container/index.jsx